import { EVENT_TYPE, MAIN_IDENTIFIER_TYPE } from 'src/features/eventLog/types';
import { Translation } from 'src/types';
import { DisplaySettingValue } from 'src/features/systems/utils/displaySettingTypes';

export enum SYSTEM_SETTINGS_CATEGORY {
    VISITORS = 'visitors',
    SYSTEM = 'system',
    GATEWAY_DISPLAY = 'gateway_display',
}

export enum SYSTEM_SETTINGS_CODE {
    SUPPORTED_IDENTIFIER_TYPES = 'supported_identifier_types',
    MAIN_IDENTIFIER_TYPE = 'main_identifier_type',
    ENABLED_MEMBERSHIP_CATEGORIES = 'enabled_membership_categories',
    ENABLED_EVENT_TYPES = 'enabled_event_types',
    SUCCESSFUL_ENTRANCE_MESSAGE = 'successful_entrance_message',
    REJECTED_ENTRANCE_MESSAGE = 'rejected_entrance_message',
    SUCCESSFUL_EXIT_MESSAGE = 'successful_exit_message',
    REJECTED_EXIT_MESSAGE = 'rejected_exit_message',
    DATE_MESSAGE = 'date_message',
    SPACES_MESSAGE = 'spaces_message',
    LPR_MESSAGE = 'lpr_message',
    TICKET_MESSAGE = 'ticket_message',
    CARD_MESSAGE = 'card_message',
}

export enum MEMBERSHIP_CATEGORY {
    VIP = 'vip',
    RESIDENT = 'resident',
    STAFF = 'staff',
    SERVICE = 'service',
    SUBSCRIPTION = 'subscription',
    RESERVATION = 'reservation',
}

type SystemSettingsValue =
    | EVENT_TYPE[]
    | MAIN_IDENTIFIER_TYPE[]
    | MAIN_IDENTIFIER_TYPE
    | MEMBERSHIP_CATEGORY[]
    | DisplaySettingValue;

export type SystemSettings = {
    id: string;
    created_at: string;
    modified_at: string;
    category: SYSTEM_SETTINGS_CATEGORY;
    code: SYSTEM_SETTINGS_CODE;
    value: SystemSettingsValue;
};

export enum SYSTEM_COMPONENT_TYPE {
    SOFTWARE = 'software',
    HARDWARE_DEVICE = 'hardware_device',
}

export enum SYSTEM_COMPONENT {
    LPR_CAMERA = 'lpr_camera',
    ACCESS_KEY_READER_COMMUNICATOR = 'access_key_reader_communicator',
    GATEWAY_COMMUNICATOR = 'gateway_communicator',
    SENSOR_READER_COMMUNICATOR = 'sensor_reader_communicator',
    BANKNOTE_VALIDATOR = 'banknote_validator',
    COIN_HOPPER = 'coin_hopper',
    COIN_MECHANISM = 'coin_mechanism',
    COIN_ACCEPTOR = 'coin_acceptor',
    CCTALK_INTERFACE = 'cctalk_interface',
    GATEWAY_DISPLAY = 'gateway_display',
}

export enum BANKNOTE_VALIDATOR_MANUFACTURER {
    JCM = 'jcm',
    INNOVATIVE_TECHNOLOGY = 'innovative-technology',
}

export enum COIN_HOPPER_MANUFACTURER {
    WH_MUNZPRUFER = 'wh-munzprufer',
    INNOVATIVE_TECHNOLOGY = 'innovative-technology',
}

export enum COIN_MECHANISM_ACCEPTOR_MANUFACTURER {
    WH_MUNZPRUFER = 'wh-munzprufer',
}

export enum CCTALK_INTERFACE_MODAL {
    CCT_900 = 'cct-900',
    CCT_910 = 'cct-910',
}

export enum COMMUNICATOR_TYPE {
    SP_MQTT = 'SP_MQTT',
}

export enum CAMERA_TYPE {
    SP_LPR = 'sp_lpr',
}

export enum SYSTEM_COMPONENT_STATUS {
    OPERATIONAL = 'operational',
    WARNING = 'warning',
    ERROR = 'error',
    NO_CONNECTION = 'no_connection',
}

export enum GATEWAY_DISPLAY_MODEL {
    SP = 'SP',
    HUIDU = 'HUIDU',
    NED200 = 'NED200',
}

export enum ORIENTATION {
    PORTRAIT = 'portrait',
    LANDSCAPE = 'landscape',
}

export enum LISTEN_STATE {
    OPEN = 'open',
    CLOSED = 'closed',
}

export enum IDLE_STATE {
    DATE = 'date',
    SPACES = 'spaces',
    LPR = 'lpr',
    TICKET = 'ticket',
    CARD = 'card',
}

export type DataJson = {
    type?: CAMERA_TYPE | COMMUNICATOR_TYPE;
    make?: string;
    model?: string | GATEWAY_DISPLAY_MODEL;
    serial_number?: string;
    rtsp_stream_url?: string;
    channel?: number;
    topic_code?: string;
    persistent_channel?: number;
    open_duration?: number;
    currency_dataset?: string;
    firmware_version?: string;
    manufacturer?: string;
    display_server_ip?: string;
    display_server_api_key?: string;
    listen_state?: LISTEN_STATE;
    status_channel?: number;
    status_listen_state?: LISTEN_STATE;
    idle_state?: IDLE_STATE;
    orientation?: ORIENTATION;
    sdk_key?: string;
    sdk_secret?: string;
    device_id?: string;
    screen_width?: number;
    screen_height?: number;
    display_model?: GATEWAY_DISPLAY_MODEL;
};

export type SystemComponent = {
    id: string;
    created_at: string;
    modifier_at: string;
    component_type: SYSTEM_COMPONENT_TYPE;
    component: SYSTEM_COMPONENT;
    name: string;
    status: SYSTEM_COMPONENT_STATUS;
    data?: DataJson;
    code: string;
    zone?: {
        id: string;
        translations: Translation[];
    };
    gateway?: {
        id: string;
        translations: Translation[];
    };
    pay_station?: {
        id: string;
        name: string;
    };
};
